<template>
  <div>
    <HeaderTop ref="shopcar"></HeaderTop>
    <!-- 页头标题板块 -->
    <div class="allTitle">
      <div class="titleCenter">
        <div class="left">
          <img src="@/assets/images/home/logo1.png" alt="" />
          <span>商品维护</span>
        </div>
        <div class="titleBtn">
          <Button
            class="btn"
            @click="onlyeSaveBtn('仅保存')"
            :loading="onlySaveLoading"
            >仅保存</Button
          >
          <Button
            class="btn"
            @click="onlyeSaveBtn('保存并上架')"
            :loading="saveLoading"
            >保存并上架</Button
          >
        </div>
        <!-- 左边锚点 -->
        <div class="point">
          <Anchor
            :affix="false"
            :show-ink="false"
            :scroll-offset="offset"
            @on-select="selectBTN"
          >
            <div
              :class="[{ aaa: true }, { da: !shadowHeight }]"
              @click="clickasd"
            >
              基础信息
            </div>
            <!-- <AnchorLink href="#basics" title="基础信息" /> -->
            <AnchorLink href="#sell" title="销售信息" />
            <AnchorLink href="#afterSales" title="售后信息" />
            <AnchorLink href="#describe" title="图文描述" />
            <AnchorLink href="#replace" title="替换链" />
            <AnchorLink href="#carType" title="适用车型" />
            <AnchorLink href="#record" title="维护记录" />
          </Anchor>
        </div>
      </div>
      <div v-if="shadowHeight" class="shadow"></div>
    </div>
    <div class="center">
      <!-- 右边内容 -->
      <div class="table">
        <!-- 基础信息 -->
        <div class="title"><span>基础信息</span></div>
        <div class="tableCenter" id="basics">
          <Row>
            <Col span="8"
              ><div class="tableTh">配件编码：</div>
              <span> {{ goodsData.oeCode }}</span></Col
            >
            <Col span="8"
              ><div class="tableTh">配件类型：</div>
              <span> {{ goodsData.typeName }}</span></Col
            >
            <Col span="8"
              ><div class="tableTh">品牌：</div>
              <span> {{ goodsData.carBrandName }}</span></Col
            >
          </Row>
          <Row>
            <Col span="8"
              ><div class="tableTh">标准分组：</div>
              <span> {{ goodsData.partTypeName }}</span></Col
            >
            <Col span="8"
              ><div class="tableTh">标准名称：</div>
              <span> {{ goodsData.stdNameJp }}</span></Col
            >
            <Col span="8"
              ><div class="tableTh">配件名称：</div>
              <span> {{ goodsData.fullName }}</span></Col
            >
          </Row>

          <Row>
            <Col span="8">
              <!-- <div class="tableTh">单位：</div> -->
              <Form
                ref="unitForm"
                :model="goodsData"
                :show-message="false"
                :rules="unitRules"
                :label-width="80"
              >
                <FormItem label="单位：" prop="unitId">
                  <Select
                    label-in-value
                    v-model="goodsData.unitId"
                    placeholder="单位"
                  >
                    <Option
                      v-for="item in unitList"
                      :value="item.itemName"
                      :key="item.itemName"
                      >{{ item.itemName }}</Option
                    >
                  </Select>
                </FormItem>
              </Form>
            </Col>
            <Col span="8"
              ><div class="tableTh">方向：</div>
              <Select
                label-in-value
                multiple
                v-model="goodsData.directionList"
                placeholder="无"
              >
                <Option
                  v-for="item in directionList"
                  :value="item.itemName"
                  :key="item.itemName"
                  >{{ item.itemName }}</Option
                >
              </Select></Col
            >
            <Col span="8"
              ><div class="tableTh">是否进口：</div>
              <RadioGroup v-model="goodsData.isImport">
                <Radio label="0">否</Radio>
                <Radio label="1">是</Radio>
              </RadioGroup></Col
            >
          </Row>
          <Row>
            <Col span="24"
              ><div class="tableTh">配件图片：</div>
              <UploadImgs ref="uploadImgs" @getImg="getImg"></UploadImgs>
            </Col>
          </Row>
        </div>
        <!-- 销售信息 -->
        <div class="title"><span>销售信息</span></div>
        <div class="tableCenter" id="sell">
          <Row>
            <Col span="24"
              ><Form
                ref="sellForm"
                :model="sellData"
                :rules="sellRoules"
                :label-width="100"
              >
                <FormItem label="价格类型：" prop="priceType">
                  <RadioGroup v-model="sellData.priceType">
                    <Radio label="0">一口价</Radio>
                    <Radio label="1">阶梯价格</Radio>
                  </RadioGroup>
                </FormItem>
                <FormItem label="价格：" prop="price">
                  <!-- <ul class="priceType"> -->
                  <ul class="priceType" v-if="sellData.priceType == 1">
                    <li
                      v-for="(item, index) in sellData.priceListOne"
                      :key="index"
                    >
                      <div>{{ index == 0 ? '起订量' : '购买' }}</div>
                      <Input
                        v-model="item.orderQuantity"
                        placeholder="数量..."
                        @on-focus="priceEvent(index)"
                        size="small"
                        style="width: 100px; margin-right: 10px"
                      />
                      <span style="padding-right: 10px">个单位及以上</span>
                      <Input
                        v-model="item.price"
                        placeholder="价格..."
                        size="small"
                        style="width: 100px; margin-left: 0"
                      />元/单位
                      <Icon
                        v-if="index !== 0"
                        type="md-remove-circle"
                        color="#e90d0d"
                        size="16"
                        class="removeBtn"
                        @click="priceDel(index)"
                      />
                    </li>
                    <li class="maxTip" v-if="sellData.priceListOne.length >= 5">
                      <Icon
                        type="ios-alert-outline"
                        size="20"
                        color="#0074ff"
                      />
                      <span>最多只能添加5次</span>
                    </li>
                  </ul>
                  <ul class="priceType" v-else>
                    <li
                      v-for="(item, index) in sellData.priceListZero"
                      :key="index"
                    >
                      <Input
                        v-model="item.price"
                        placeholder="价格..."
                        size="small"
                        style="width: 100px"
                      />元/单位
                    </li>
                  </ul>
                </FormItem>
                <FormItem label="库存：" prop="stock">
                  <Input
                    v-model="sellData.stock"
                    size="small"
                    style="width: 200px"
                    placeholder="库存"
                  ></Input>
                </FormItem>
                <FormItem label="规格参数：">
                  <ul class="partsSpecVOList">
                    <li
                      v-for="(item, index) in sellData.partsSpecVOList"
                      :key="index"
                      class="standard"
                    >
                      <Input
                        v-model="item.name"
                        placeholder="请输入规格参数名称..."
                        @on-focus="parameEvent(index)"
                        size="small"
                        style="width: 200px"
                      />
                      <Input
                        v-model="item.value"
                        placeholder="请输入规格参数值..."
                        size="small"
                        style="width: 200px"
                      />
                      <Icon
                        v-if="index !== 0"
                        type="md-remove-circle"
                        color="#e90d0d"
                        size="16"
                        class="removeBtn"
                        @click="paramsDel(index)"
                      />
                    </li>
                    <li
                      class="maxTip"
                      v-if="sellData.partsSpecVOList.length >= 20"
                    >
                      <Icon
                        type="ios-alert-outline"
                        size="20"
                        color="#0074ff"
                      />
                      <span>库存最多只能添加20次</span>
                    </li>
                  </ul>
                </FormItem></Form
              ></Col
            ></Row
          >
        </div>
        <!-- 售后服务 -->
        <div class="title"><span>售后服务</span></div>
        <div class="tableCenter" id="afterSales">
          <Row>
            <Col span="24">
              <div class="tableTh">售后服务：</div>
              <CheckboxGroup v-model="sellAfter">
                <Checkbox label="正品保证" disabled></Checkbox>
                <Checkbox label="提供发票"></Checkbox>
                <Checkbox label="保修服务"></Checkbox>
                <Checkbox label="退换货承诺"></Checkbox>
              </CheckboxGroup> </Col
          ></Row>
          <Row>
            <Col span="24">
              <div class="tableTh">无货处理：</div>
              <RadioGroup v-model="stockout">
                <Radio label="1">下架</Radio>
                <Radio label="2">变为询价</Radio>
              </RadioGroup></Col
            ></Row
          >
        </div>
        <!-- 图文描述 -->
        <div class="title"><span>图文描述</span></div>
        <div class="tableCenter" id="describe">
          <Button class="btn" v-show="!SHow" @click="btnOK">完成</Button>
          <Button class="btn" v-show="SHow" @click="SHow = false">编辑</Button>
          <div class="quill-div" v-show="!SHow">
            <Uploadify
              id="upload"
              :options="options"
              @getOssRes="getOssRes"
              ref="uploadify"
            ></Uploadify>
            <quill-editor
              ref="editor"
              v-model="description.content"
              :options="editorOption"
            >
            </quill-editor>
          </div>
          <!-- 富文本渲染 -->
          <div class="showhtml" v-show="SHow">
            <div v-html="html">请编辑好公司的情况</div>
          </div>
        </div>
        <!-- 替换链 -->
        <div class="title"><span>替换链</span></div>
        <div class="tableCenter" id="replace">
          <Row>
            <Col span="24"
              ><div style="width: 120px">关联原厂件：</div>
              <vxe-table
                size="mini"
                max-height="300"
                border
                show-header-overflow
                show-overflow
                align="center"
                :row-config="{ isHover: true }"
                :data="originalData"
              >
                <vxe-column min-width="200" field="code" title="配件编码">
                  <template #default="{ row }">
                    <span>{{ row.parts.oeCode }}</span>
                  </template>
                </vxe-column>

                <vxe-column min-width="200" field="name" title="标准名称">
                  <template #default="{ row }">
                    <span>{{ row.parts.fullName }}</span>
                  </template></vxe-column
                >
                <vxe-column min-width="200" field="brand" title="品牌">
                  <template #default="{ row }">
                    <span>{{ row.parts.carBrandName }}</span>
                  </template></vxe-column
                >
                <vxe-column min-width="200" field="type" title="配件类型">
                  <template #default="{ row }">
                    <span>{{ row.parts.qualityTypeId.name }}</span>
                  </template></vxe-column
                >
              </vxe-table>
            </Col></Row
          >
          <br />
          <Row>
            <Col span="24"
              ><div style="width: 120px">品牌件替换：</div>
              <vxe-table
                size="mini"
                max-height="300"
                border
                show-header-overflow
                show-overflow
                align="center"
                :row-config="{ isHover: true }"
                :data="brandData"
              >
                <vxe-column min-width="200" field="code" title="配件编码">
                  <template #default="{ row }">
                    <span>{{ row.parts.oeCode }}</span>
                  </template></vxe-column
                >
                <vxe-column min-width="200" field="name" title="标准名称">
                  <template #default="{ row }">
                    <span>{{ row.parts.fullName }}</span>
                  </template></vxe-column
                >
                <vxe-column min-width="200" field="brand" title="品牌">
                  <template #default="{ row }">
                    <span>{{ row.parts.carBrandName }}</span>
                  </template></vxe-column
                >
                <vxe-column min-width="200" field="type" title="配件类型">
                  <template #default="{ row }">
                    <span>{{ row.parts.qualityTypeId.name }}</span>
                  </template></vxe-column
                >
              </vxe-table>
            </Col></Row
          >
        </div>
        <!-- 适用车型 -->
        <div class="title"><span>适用车型</span></div>
        <div class="tableCenter CarTypebox" id="carType">
          <Row>
            <Col span="24">
              <div class="tableCarTh">车厂牌</div>
              <ul>
                <li
                  v-for="(item, index) in carBrandName"
                  :key="index"
                  @click="selectTypeData(item, 'brandBtn')"
                  :class="carType.brandBtn == item ? 'checked' : ''"
                >
                  {{ item }}
                </li>
              </ul></Col
            ></Row
          >
          <Row>
            <Col span="24">
              <div class="tableCarTh">主机厂</div>
              <ul>
                <li
                  v-for="(item, index) in factoryName"
                  :key="index"
                  @click="selectTypeData(item, 'hostBtn')"
                  :class="carType.hostBtn == item ? 'checked' : ''"
                >
                  {{ item }}
                </li>
              </ul>
            </Col></Row
          >
          <Row>
            <Col span="24">
              <div class="tableCarTh">车系</div>
              <ul>
                <li
                  v-for="(item, index) in carBrandSeriesName"
                  :key="index"
                  @click="selectTypeData(item, 'seriesBtn')"
                  :class="carType.seriesBtn == item ? 'checked' : ''"
                >
                  {{ item }}
                </li>
              </ul></Col
            ></Row
          >
          <Row>
            <Col span="24">
              <div class="tableCarTh">车型</div>
              <div style="width: 100%; text-align: left">
                <vxe-table
                  size="mini"
                  align="center"
                  border
                  resizable
                  show-overflow
                  max-height="300"
                  :scroll-y="{ enabled: false }"
                  :span-method="rowspanMethod"
                  :data="carList"
                >
                  <vxe-column
                    field="name"
                    width="260"
                    title="车型名称"
                  ></vxe-column>
                  <vxe-column
                    field="modelYear"
                    width="80"
                    title="年款"
                  ></vxe-column>
                  <vxe-column
                    field="displacement"
                    width="80"
                    title="排量"
                  ></vxe-column>
                  <vxe-column
                    width="250"
                    field="transmissionDescribe"
                    title="变速箱"
                  ></vxe-column>
                  <vxe-column
                    width="60"
                    field="gearsNum"
                    title="挡位"
                  ></vxe-column>
                  <vxe-column
                    width="210"
                    field="engineNo"
                    title="发动机"
                  ></vxe-column>
                </vxe-table>
              </div> </Col
          ></Row>
        </div>
        <!-- 维护记录 -->
        <div class="title"><span>维护记录</span></div>
        <div
          class="tableCenter"
          id="record"
          style="border-bottom: 1px solid #e2e2e2"
        >
          <vxe-table
            size="mini"
            border
            show-header-overflow
            show-overflow
            align="center"
            :row-config="{ isHover: true }"
            :data="partLogData"
            style="width: 914px; margin: 0 auto"
          >
            <vxe-column
              width="457"
              field="createUname"
              title="修改人"
            ></vxe-column>
            <vxe-column
              field="createTime"
              width="457"
              title="修改时间"
            ></vxe-column>
          </vxe-table>
          <vxe-pager
            background
            align="right "
            size="mini"
            max-height="400"
            style="padding-right: 70px; padding-top: 20px"
            :current-page.sync="pager.current"
            :page-size.sync="pager.size"
            :total="pager.total"
            @page-change="handlePageChange"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'Number',
              'NextPage',
              'NextJump',
              'Sizes',
              'FullJump',
              'Total'
            ]"
          >
            >
          </vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 接口
import {
  getGoodsMassage,
  getcarType,
  listRelationByPartId,
  listReplaceByPartId,
  getPartLogById,
  partSave
} from '@/api/myweb/goods/goodsManage'
import { getDataFrom } from '@/api/myweb/goods/goodsManagement'
// 其他
import HeaderTop from '../../../../base/common/header-top.vue'
import UploadImgs from './components/uploadImgs.vue'
import Uploadify from '@/views/base/uploadify/upload.vue'
// 富文本工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'strike'], // 加粗 斜体 下划线 删除线
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  ['link', 'image'], // 链接、图片、视频
  [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
  [{ align: [] }] // 对齐方式
]
export default {
  components: {
    HeaderTop,
    UploadImgs,
    Uploadify
  },

  data() {
    const priceValidatePass = (rule, value, callback) => {
      let priceReg =
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (this.sellData.priceType == 0) {
        if (!this.sellData.priceListZero[0].price) {
          callback(new Error('一口价价格为必填项'))
        } else {
          if (!priceReg.test(this.sellData.priceListZero[0].price)) {
            callback(new Error('价格大于0且最多两位小数'))
          } else {
            callback()
          }
        }
      }
      if (this.sellData.priceType == 1) {
        let priceNum = 0
        let num = 0
        let reg = /^[1-9]\d*$/

        this.sellData.priceListOne.forEach((item) => {
          // 判断有效列表数量
          if (item.orderQuantity) {
            num++
            // 判断数量是否为正整数
            if (!reg.test(item.orderQuantity)) {
              callback(new Error('数量为正整数'))
            }
            if (item.price) {
              // 判断价格是否为>0且最多两位小数
              if (!priceReg.test(item.price)) {
                callback(new Error('价格大于0且最多两位小数'))
              }
            } else {
              priceNum++
            }
          }
        })
        if (priceNum != 0) {
          callback(new Error('阶梯价格价格为必填项'))
        } else {
          if (num < 2) {
            callback(new Error('请至少设置2个阶梯'))
          } else {
            callback()
          }
        }
      }
    }
    return {
      options: {
        size: 6,
        optionbtn: false,
        optionbtn1: false,
        edit: true,
        fileType: ['jpg', 'png', 'jpeg', 'psd', 'gif', 'bmp']
      },
      saveLoading: false,
      onlySaveLoading: false,
      html: '', // 富文本渲染
      SHow: true, // 富文本显示
      description: {}, // 富文本
      shadowHeight: false,
      offset: 200,
      // offset: 0,
      editorOption: {
        placeholder: '请编辑商品描述...',
        theme: 'snow', // 默认主题
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#upload .ivu-icon').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      // 可用数据
      // 单位列表
      unitList: [],

      // 单位校验规则
      unitRules: {
        unitId: [
          {
            required: true,
            message: '单位为必填',
            trigger: 'change'
          }
        ]
      },
      // 方向列表
      directionList: [],
      // 销售表单
      sellData: {
        priceType: '', //价格类型
        priceListZero: [{ orderQuantity: 1, price: '' }], // 一口价价格列表
        priceListOne: [{ orderQuantity: '', price: '' }], // 阶梯价格列表
        stock: '', // 库存
        partsSpecVOList: [{ name: '', value: '' }] //规格参数
      },
      // 销售表单验证规则
      sellRoules: {
        priceType: [
          { required: true, message: '请选择价格类型', trigger: 'change' }
        ],
        price: [
          { required: true, validator: priceValidatePass, trigger: 'change' }
        ],
        stock: [
          {
            required: true,
            message: '请输入库存',
            trigger: 'change'
          },
          {
            pattern: /^[1-9]\d*$/,
            message: '请输入正整数',
            trigger: 'blur'
          }
        ]
      },
      qualityTypeId: '',
      goodsData: {
        oeCode: '', //配件编码
        typeName: '', //配件类型
        carBrandName: '', //品牌
        partTypeName: '', //标准分组
        stdNameJp: '', //标准名称
        fullName: '', //配件名称
        unitId: '', //单位
        direction: '', //方向
        isImport: '', //进口
        partsImgVOList: [], //图片
        value9: [] //售后服务
      },
      stockout: '', //无货状态
      // 售后信息
      sellAfter: ['正品保证'],
      // 替换链
      originalData: [], //关联原厂件
      brandData: [], //品牌件替换
      // 记录
      pager: {
        current: 0,
        size: 10,
        total: 0
      },
      // 车型查询
      carBrandName: [], //车厂牌
      factoryName: [], //主机厂
      carBrandSeriesName: [], //车系
      carType: {
        brandBtn: '',
        hostBtn: '',
        seriesBtn: ''
      },
      carList: [], // 适用车系
      // 操作记录
      partLogData: []
    }
  },
  mounted() {
    // 监听滚动条
    window.addEventListener('scroll', this.handleScroll)
    console.log(window.addEventListener('scroll', this.handleScroll))
  },
  created() {
    console.log(this.$route)
    this.getGoodsMassage()
    this.getUnitList()
    this.getcarType(1)
    this.getPartLogById()
  },
  methods: {
    selectBTN(val) {
      console.log(val)
      // console.log(window.addEventListener('scroll', this.handleScroll));
    },
    // 获取配件所有信息
    async getGoodsMassage() {
      // let partId = this.$route.query.partId
      let partId = JSON.parse(sessionStorage.getItem('editIds')).partId
      if (!partId) {
        this.$Message.error('配件信息缺失，请重新进入')
        return
      }
      let res = await getGoodsMassage({ partId })
      if (res.status) {
        this.qualityTypeId = res.data.qualityTypeId
        this.$nextTick(() => {
          // 基础信息
          this.goodsData = res.data
          this.goodsData.isImport = this.goodsData.isImport
            ? this.goodsData.isImport + ''
            : '0'
          this.goodsData.unitId = this.goodsData.unitId
            ? this.goodsData.unitId
            : '个'
          this.$refs.uploadImgs.getImgs(this.goodsData.partsImgVOList)

          // 销售信息
          this.sellData = {
            priceType: res.data.partsPriceVO.priceType
              ? res.data.partsPriceVO.priceType
              : '', //价格类型
            stock: res.data.stock + '', // 库存
            partsSpecVOList: res.data.partsSpecVOList, //规格参数
            priceListOne: [],
            priceListZero: []
          }
          this.stockout = res.data.sellOut
          if (this.sellData.priceType == 1) {
            this.sellData.priceListOne = res.data.partsPriceVO.priceVOS
              ? res.data.partsPriceVO.priceVOS
              : [{}] // 价格列表
            this.sellData.priceListZero = [{ orderQuantity: 1, price: '' }]
            if (this.sellData.priceListOne.length < 5) {
              this.sellData.priceListOne.push({})
            }
          } else {
            this.sellData.priceListZero = res.data.partsPriceVO.priceVOS
              ? res.data.partsPriceVO.priceVOS
              : [{ orderQuantity: 1, price: '' }] // 价格列表
            this.sellData.priceListOne = [{}]
          }
          this.sellData.partsSpecVOList.push({})
          // 售后服务
          if (this.goodsData.genuineGuarantee == 1) {
            this.sellAfter.push('正品保证')
          }
          if (this.goodsData.technicalSupport == 1) {
            this.sellAfter.push('提供发票')
          }
          if (this.goodsData.warrantyService == 1) {
            this.sellAfter.push('保修服务')
          }
          if (this.goodsData.returnPromise == 1) {
            this.sellAfter.push('退换货承诺')
          }
        })
        // 图文描述
        this.description.content = res.data.content
        this.html = res.data.content
        this.listRelationByPartId()
        this.listReplaceByPartId()
      }
    },
    // 获取单位和方向数组
    async getUnitList() {
      let res = await getDataFrom(['UNIT-CODE', 'FX'])
      this.unitList = res.data['UNIT-CODE']
      this.directionList = res.data['FX']
    },
    // 查询适用车型
    selectTypeData(index, name) {
      this.$set(this.carType, name, index)
      // this.carType[name] == index
      this.getcarType(0)
    },
    // 获取适用车型
    async getcarType(num) {
      let data = {
        // partId: this.$route.query.partId,
        partId: JSON.parse(sessionStorage.getItem('editIds')).partId,
        carBrandName:
          this.carType.brandBtn == '暂无' ? '' : this.carType.brandBtn,
        factoryName: this.carType.hostBtn == '暂无' ? '' : this.carType.hostBtn,
        carBrandSeriesName:
          this.carType.seriesBtn == '暂无' ? '' : this.carType.seriesBtn
      }
      let res = await getcarType(data)
      if (res.status) {
        this.carBrandName = res.data.carBrandName
          ? res.data.carBrandName
          : ['暂无']
        this.factoryName = res.data.factoryName
          ? res.data.factoryName
          : ['暂无']
        this.carBrandSeriesName = res.data.carBrandSeriesName
          ? res.data.carBrandSeriesName
          : ['暂无']
        this.carList = res.data.chirdren
        if (num) {
          this.carType = {
            brandBtn: this.carBrandName[0],
            hostBtn: this.factoryName[0],
            seriesBtn: this.carBrandSeriesName[0]
          }
        }
      }
    },
    // 价格类型变化
    changeRadio() {
      // this.sellData.priceList = [{}]
      // for (let item of this.$refs.sellForm.fields) {
      //   if (item.prop === 'price') {
      //     item.resetField()
      //     break
      //   }
      // }
      // this.sellData.priceList = [{}]
      // if (this.sellData.priceType == 0) {
      //   this.sellData.priceList = [{ orderQuantity: 1, price: '' }]
      // }
    },
    // 销价价格变化事件
    priceEvent(index) {
      if (
        index == this.sellData.priceListOne.length - 1 &&
        this.sellData.priceListOne.length < 5
      ) {
        this.sellData.priceListOne.push({})
      }
    },
    // 价格删除事件
    priceDel(index) {
      this.sellData.priceListOne.splice(index, 1)
    },
    // 规格删除事件
    paramsDel(index) {
      this.sellData.partsSpecVOList.splice(index, 1)
    },
    // 规格参数变化事件
    parameEvent(index) {
      if (
        index == this.sellData.partsSpecVOList.length - 1 &&
        this.sellData.partsSpecVOList.length < 20
      )
        this.sellData.partsSpecVOList.push({})
    },
    // 图文描述
    async btnOK() {
      this.SHow = true
      this.html = this.description.content
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    rowspanMethod({ row, _rowIndex, column, visibleData }) {
      let fields = ['name', 'modelYear']
      let cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        let prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (column.property === 'modelYear') {
          if (
            prevRow &&
            prevRow[column.property] === cellValue &&
            prevRow['name'] === row['name']
          ) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (
              nextRow &&
              nextRow[column.property] === cellValue &&
              nextRow['name'] === row['name']
            ) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }

            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        } else {
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      }
    },
    // 固定定位阴影
    handleScroll() {
      let scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollHeight)
      if (scrollHeight > 0) {
        this.shadowHeight = true
      } else {
        this.shadowHeight = false
      }
    },
    clickasd(e) {
      setTimeout(() => {
        document.documentElement.scrollTop = 0
      }, 100)
    },
    // 关联链
    async listRelationByPartId() {
      // let partId = this.$route.query.jiapeiPartId
      let partId = JSON.parse(sessionStorage.getItem('editIds')).jiapeiPartId
      let res = await listRelationByPartId({ partId })
      if (this.qualityTypeId == 70) {
        this.brandData = res.data
      } else {
        this.originalData = res.data
      }
    },
    // 替换链
    async listReplaceByPartId() {
      // let partId = this.$route.query.jiapeiPartId
      let partId = JSON.parse(sessionStorage.getItem('editIds')).jiapeiPartId
      let res = await listReplaceByPartId({ partId })
      if (this.qualityTypeId == 70) {
        this.originalData = res.data
      } else {
        this.brandData = res.data
      }
    },
    // 记录维护日志获取
    async getPartLogById() {
      let data = {
        current: this.pager.current,
        size: this.pager.size,
        // partId: this.$route.query.partId
        partId: JSON.parse(sessionStorage.getItem('editIds')).partId
      }
      let res = await getPartLogById(data)
      if (res.status) {
        this.partLogData = res.data.records
        this.pager = {
          current: res.data.current,
          size: res.data.size,
          total: res.data.total
        }
      }
    },
    // 记录分页
    handlePageChange({ currentPage, pageSize }) {
      this.pager.current = currentPage
      this.pager.size = pageSize
      this.getPartLogById()
    },
    // 图片
    getImg(imgList) {
      this.goodsData.partsImgVOList = imgList
    },
    // 仅保存
    onlyeSaveBtn(saveWay) {
      this.$refs.unitForm.validate((valid) => {
        if (valid) {
          this.$refs.sellForm.validate(async (valid) => {
            if (valid) {
              let data = JSON.parse(JSON.stringify(this.goodsData))
              data.stock = this.sellData.stock
              data.partsSpecVOList = this.sellData.partsSpecVOList
              data.partsPriceVO.priceType = this.sellData.priceType
              data.partsPriceVO.priceVOS =
                this.sellData.priceType == 0
                  ? this.sellData.priceListZero
                  : this.sellData.priceListOne
              // 售后
              data.genuineGuarantee =
                this.sellAfter.indexOf('正品保证') == -1 ? '0' : '1'
              data.technicalSupport =
                this.sellAfter.indexOf('提供发票') == -1 ? '0' : '1'
              data.warrantyService =
                this.sellAfter.indexOf('保修服务') == -1 ? '0' : '1'
              data.returnPromise =
                this.sellAfter.indexOf('退换货承诺') == -1 ? '0' : '1'
              // 图文描述
              data.content = this.description.content
              data.sellOut = this.stockout
              if (saveWay == '保存并上架') {
                data.saleStatus = 1
                this.saveLoading = true
              } else {
                this.onlySaveLoading = true
              }
              let res = await partSave(data)
              if (res.status) {
                this.$Message.success('保存成功!')

                if (saveWay == '保存并上架') {
                  this.$router.push({
                    path: '/successPage'
                  })
                }
              }
              this.saveLoading = false
              this.onlySaveLoading = false
            } else {
              this.$Message.destroy()
              this.$Message.error('请完善必填信息!')
            }
          })
        } else {
          this.$Message.destroy()
          this.$Message.error('请完善必填信息!')
        }
      })
    },
    // 富文本图片
    getOssRes(res) {
      let quill = this.$refs.editor.quill
      let length = quill.getLength()
      quill.insertEmbed(length, 'image', res.url)
      quill.setSelection(length + 1)
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
.aaa {
  font-weight: bold;
  padding: 8px 0 8px 16px;
  cursor: pointer;
  color: #000;
}
.aaa:hover {
  color: #515a6e;
}
.da {
  color: #2d8cf0 !important;
}
</style>
